import { IModalState } from '../../types/modalState';
import { EModalActionTypes } from '../../actions/modal';
import { TReduxActions } from '../../actions';

const defaultState: IModalState = {
  open: false,
};

export function modalReducer(state: IModalState = defaultState, action: TReduxActions): IModalState {
  switch (action.type) {
    case EModalActionTypes.ModalOpen:
      return {
        ...state,
        open: true,
      };
    case EModalActionTypes.ModalClose:
      return {
        ...state,
        open: false,
      };
  }

  return state;
}
